import React from "react";
import "./MiniOfferCard.css";

interface MiniOfferCardProps {
  trackId: string;
  searchQuery: string;
  trackArtists: string[];
  amount?: number | null;
  currency?: string;
  avatarUrl?: string;
  status: "played" | "declined";
}

const MiniOfferCard: React.FC<MiniOfferCardProps> = ({
  trackId,
  searchQuery,
  trackArtists,
  amount,
  currency,
  avatarUrl,
  status,
}) => {
  const safeAmount = Number.isFinite(Number(amount)) ? Number(amount) : 0;

  const normCur = (cur?: string) =>
    String(cur || "")
      .trim()
      .toLowerCase();
  const curSym = (cur?: string) => {
    switch (normCur(cur)) {
      case "usd":
        return "$";
      case "eur":
        return "€";
      case "gbp":
        return "£";
      case "rub":
        return "₽";
      default:
        return "$";
    }
  };

  return (
    <div className={`mini-offer-card ${status}`}>
      <a
        href={`https://open.spotify.com/track/${trackId}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src={avatarUrl || "/fallback.png"}
          alt="Track"
          className="mini-track-img"
          onError={(e) => {
            (e.currentTarget as HTMLImageElement).src = "/fallback.png";
          }}
        />
      </a>
      <div className="mini-details">
        <div className="mini-title">{searchQuery}</div>
        <div className="mini-artist">{(trackArtists || []).join(", ")}</div>
        <div className="mini-amount">
          {curSym(currency)}
          {safeAmount.toFixed(2)}
        </div>
      </div>
    </div>
  );
};

export default MiniOfferCard;
